import { globalApi } from '@rcm/redux-global';
import { CartOrderHttpResponseData } from 'cart-core';
import axios from 'axios';
import { assertIsAxiosError } from '@rcm/axios-utils';
import { GtagCartUpdateMethod, sendAnalyticsEvents } from 'google-analytics';

const api = globalApi.enhanceEndpoints({
    addTagTypes: ['CartCurrentOrder'],
}).injectEndpoints({
    endpoints: (build) => ({
        currentOrder: build.query<CartOrderHttpResponseData, void>({
            query: () => ({
                method: 'GET',
                url: '/api/cart/order/current'
            }),
            providesTags: ['CartCurrentOrder']
        }),
        currentOrderAddItems: build.mutation({
            queryFn: async (args: {
                skus: Array<{
                    data?: unknown;
                    qty: number;
                    skuNumber: string;
                    type?: string;
                }>;
                cart_update_method: GtagCartUpdateMethod;
            }) => {
                try {
                    const items = (await axios.get<CartOrderHttpResponseData>(
                        '/api/cart/order/current',
                    )).data.data.items;
                    const oldSkusQty = Object.fromEntries(
                        items.map((item) => [item.skuNumber, item.qty])
                    );
                    const resP = await axios.patch<CartOrderHttpResponseData>(
                        '/api/cart/order/current/item',
                        Object.fromEntries(
                            args.skus.map((sku) => [sku.skuNumber, {
                                ...sku,
                                qty: (oldSkusQty[sku.skuNumber] || 0) + sku.qty
                            }])
                        )
                    );
                    await sendAnalyticsEvents({
                        event_name: 'add_to_cart',
                        event_params: {
                            cart_update_method: args.cart_update_method,
                            items: args.skus.map((sku) => ({
                                id: sku.skuNumber,
                                quantity: sku.qty
                            })),
                        }
                    });
                    return { data: resP.data };
                } catch (e: unknown) {
                    assertIsAxiosError<CartOrderHttpResponseData>(e);
                    return {
                        error: {
                            status: e.response.status,
                            data: e.response.data
                        }
                    }
                }
            },
            invalidatesTags: ['CartCurrentOrder']
        })
    }),
});

export default api;
export const {
    useCurrentOrderQuery,
    useCurrentOrderAddItemsMutation,
} = api;
